module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#share",
      toString: function () {
        return this.url;
      }
    }